import { Box, Card, CardContent, CardHeader, Grid } from '@mui/material';
import { ResponsivePie } from '@nivo/pie';

import { Optional } from '~/types';

import { DonutData } from '../types';

import { useSxStyles } from './useStyles';

type Props = {
  data: DonutData[];
  title: string;
  total: Optional<number>;
  percentageLabel?: boolean;
};

export const DonutChart: React.FunctionComponent<Props> = ({
  data,
  title,
  total,
  percentageLabel = false,
}) => {
  const sxStyles = useSxStyles();

  return (
    <Card sx={sxStyles.chartCard}>
      <CardHeader
        sx={sxStyles.chartHeader}
        title={title}
        slotProps={{
          title: {
            sx: sxStyles.chartCardTitle,
          },
        }}
      />
      <CardContent sx={sxStyles.chartCardContent}>
        <Grid container sx={sxStyles.donutChartContainer}>
          <ResponsivePie
            data={data}
            margin={{
              top: 20,
              right: 0,
              bottom: 20,
              left: 96,
            }}
            innerRadius={0.75}
            padAngle={1}
            colors={(e) => e.data.color}
            borderColor="inherit:darker(0.2)"
            arcLinkLabel={(e) =>
              percentageLabel ? `${e.data.percentageLabel}` : `${e.data.value}`
            }
            arcLinkLabelsSkipAngle={0}
            arcLinkLabelsTextColor="#000"
            arcLinkLabelsOffset={-10}
            arcLinkLabelsDiagonalLength={15}
            arcLinkLabelsStraightLength={0}
            arcLinkLabelsThickness={0}
            arcLinkLabelsColor="inherit"
            enableArcLabels={false}
            arcLabelsSkipAngle={0}
            arcLabelsTextColor="#222"
            animate={true}
            legends={[
              {
                anchor: 'bottom-left',
                direction: 'column',
                translateX: -96,
                translateY: 20,
                itemWidth: 125,
                itemHeight: 18,
                itemsSpacing: 2,
                itemDirection: 'left-to-right',
                itemTextColor: '#000',
                symbolSize: 18,
                symbolShape: 'square',
              },
            ]}
          />
          <Box sx={sxStyles.donutChartTotal}>{total}</Box>
        </Grid>
      </CardContent>
    </Card>
  );
};
